import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import images from "Assets/images";

interface BulkErrorModalProps {
  open: boolean;
  onClose: () => void;
  errorData: {
    successCount: number;
    errorCount: number;
    errors: string[];
  };
}

const BulkErrorModal: React.FC<BulkErrorModalProps> = ({
  open,
  onClose,
  errorData,
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: "80%", md: "60%" },
          maxWidth: "600px",
          maxHeight: "80vh",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 0,
          outline: "none",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 3,
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
            {t("Translation.bulk_upload_errors") || "Bulk Upload Errors"}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <img src={images.modalCloseIcon} alt="Close" style={{ width: 20, height: 20 }} />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ p: 3 }}>
          {/* Summary */}
          <Box sx={{ mb: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("Translation.upload_summary") || "Upload Summary"}:</strong>
            </Typography>
            <Typography variant="body2" color="success.main">
              {t("Translation.successful_records") || "Successful"}: {errorData?.successCount}
            </Typography>
            <Typography variant="body2" color="error.main">
              {t("Translation.failed_records") || "Failed"}: {errorData?.errorCount}
            </Typography>
          </Box>

          {/* Error List */}
          <Typography variant="body1" sx={{ mb: 2, fontWeight: 600 }}>
            {t("Translation.error_details") || "Error Details"}:
          </Typography>
          <Box
            sx={{
              maxHeight: "300px",
              overflowY: "auto",
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              p: 2,
            }}
          >
            {errorData?.errors?.map((error, index) => (
              <Typography
                key={index}
                variant="body2"
                sx={{
                  mb: 1,
                  p: 1,
                  bgcolor: "#ffeaea",
                  borderRadius: 0.5,
                  color: "#d32f2f",
                  fontSize: "0.875rem",
                }}
              >
                {error}
              </Typography>
            ))}
          </Box>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 3,
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <button
            className="btn theme-btn"
            onClick={onClose}
            style={{ minWidth: "100px" }}
          >
            {t("Translation.close") || "Close"}
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default BulkErrorModal;